import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import './css/setting.css';
import ButtonComp from "../components/button/ButtonComp";
import { formatIndianDate } from "../utils/Constant";
import CustomSearch from "../components/search/CustomSearch";
import { getAllISOCodes } from "iso-country-currency";
import {
  LoadingOutlined,
  DeleteOutlined,
  CloseCircleOutlined,
  CrownOutlined,
  StopOutlined,
} from "@ant-design/icons";
import {
  Button,
  Input,
  Modal,
  message,
  Form,
  Popconfirm,
  Tabs,
  Table,
  Col,
  Tooltip,
  Space,
} from "antd";
import Select from "react-select";

import {
  settingsUpdate,
  settingsUpdateError,
} from "../components/messages/ResponseMessages";
import UserTab from "./setting/userTabSection/userTab.jsx";
// import AddModel from "./addModel";
import DownloadTab from "./setting/downloadTab";
import BulkUploadTab from "./setting/bulkUploadTab";
import TicketList from "./supportSystem/ticketList";
import Meeting from "./setting/MeetingManage/Meeting";
import axiosInstance from "../utils/axiosInstance.js";
import { useDispatch, useSelector } from "react-redux";
import { setStoreDetails } from "../app/slice/authSlice.js";
import RightArrowIcon from "../components/icons/RightArrowIcon.jsx";
// import HoverIcon from "../components/icons/HoverIcon.jsx";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import ProfessionalCompanies from "./professional/ProfessionalCompanies.jsx";
import { useTheme } from "../utils/themeToggle/theme.jsx";
import CompanyDetails from "../components/settingPage/CompanyDetails.jsx";
import DepartmentPage from "../components/settingPage/DepartmentPage.jsx";
import ProductService from "../components/settingPage/ProductService.jsx";
import CustomFeilds from "../components/settingPage/CustomFeilds.jsx";
import DemoRequests from "../components/settingPage/DemoRequests.jsx";
dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(isYesterday);

const { TextArea } = Input;
const { TabPane } = Tabs;

const SettingsPage = () => {
  const select = useSelector((state) => state.auth);
  const company_id = select.userInfo.company_id;
  const user_role = select.userInfo.role;
  const token = select.accessToken;
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const initialTab = searchParams.get("tab") || "1";
  const [activeTab, setActiveTab] = useState(initialTab);
  const [company, setCompany] = useState();
  const [countries, setCountries] = useState();
  const [states, setStates] = useState();
  const [editMode, setEditMode] = useState(false);
  const [isCompanyCreateModalOpen, setIsCompanyCreatedModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editedCompany, setEditedCompany] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProductModal, setIsProductModal] = useState(false);
  const [companyID, setCompanyID] = useState(true);
  const [products, setProducts] = useState([]);
  const [allCompanies, setAllCompanies] = useState([]);
  const [companySearch, setCompanySearch] = useState("");
  const [isExtraFieldModalOpen, setIsExtraFieldModalOpen] = useState(false);
  const [finalPage, setFinalPage] = useState(7);
  const [deactivateModal, setDeactivateModal] = useState(false);
  const [companyId, setCompanyId] = useState([]);
  const [activeOpen, setActiveOpen] = useState(false);
  const [allCurrency, setAllCurrency] = useState([]);
  const modalText = "Are you sure you want to Activate this user?";
  const [demoRequests, setDemoRequests] = useState([]);
  const [isCustomFieldEditMode, setIsCustomFieldEditMode] = useState(false)
  const [editableExterFieldData, setEditableExterFieldData] = useState([])
  const [isEdtBaCurr, setIsEdtBaCurr] = useState('false')
  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
  const [isReadNotesModalOpen, setIsReadNotesModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [noteInput, setNoteInput] = useState("");
  const [noteLoading, setNoteLoading] = useState(false);
  const [noteList, setNoteList] = useState([]);
  const [rescheduleDate, setRescheduleDate] = useState(null);
  const [rescheduleLoading, setRescheduleLoading] = useState(false);
  const [rescheduleTime, setRescheduleTime] = useState(null);
  const [meetingIdToReschedule, setMeetingIdToReschedule] = useState(null);
  const [availableData, setAvailableData] = useState({});
  const [unavailableData, setUnavailableData] = useState({});
  const [bookedSlots, setBookedSlots] = useState(unavailableData);
  const [deletingCompanyId, setDeletingCompanyId] = useState(null);
  const [selectedTimezone, setSelectedTimezone] = useState("Asia/Kolkata");
  const [timezoneAdjustedData, setTimezoneAdjustedData] = useState({});
  const [timezoneAdjustedUnavailable, setTimezoneAdjustedUnavailable] = useState({});
  const { darkMode } = useTheme();
  const [form] = Form.useForm();
  const [addDepartmentFrom] = Form.useForm();
  const [addProductFrom] = Form.useForm();
  const chatContainerRef = useRef(null);
  const params = useParams();
  const companyid = localStorage.getItem("companyId") || params.companyId;

  const checkProduct = async () => {
    try {
      const response = await axiosInstance.get(`/contract/check_product/?company=${company_id}`, {
        customParams: config
      });
      setIsEdtBaCurr(response.data.product)
    } catch (error) {
      console.error("Error fetching demo requests:", error?.message);
    }
  };

  const fetchDemoRequests = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/demo/list/`, {
        customParams: config
      });
      setDemoRequests(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching demo requests:", error.message);
      setLoading(false);
    }
  };

  const fetchCompanies = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/company/get/`);
      setAllCompanies(response.data || []);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const onPrimum = async (value, user_id) => {
    try {
      const payload = {
        user_id,
        is_premium: value
      }
      const res = await axiosInstance.post('/is_premium/', payload);
      message.success('Succesfully Update .')
      fetchCompanies()

    } catch (error) {
      console.log('error', error)
      message.error(error?.response?.data?.error)
    }
  }

  const handleStopEmailTask = async (companyId) => {
    if (user_role?.toLowerCase() !== "superadmin") {
      message.error("Only superadmin can stop email tasks");
      return;
    }
    if (!companyId) {
      message.error("Company id is required");
      return;
    }
    try {
      const response = await axiosInstance.post("/company/stop-pending-auto-email/", {
        company_id: companyId,
      });
      message.success(response?.data?.message || "Email task stopped for this company");
    } catch (error) {
      message.error(error?.response?.data?.error || "Failed to stop email task");
    }
  };

  const handleDeleteCompany = async (companyId) => {
    if (user_role?.toLowerCase() !== "superadmin") {
      message.error("Only superadmin can delete a company");
      return;
    }
    if (!companyId) {
      message.error("Company id is required");
      return;
    }
    try {
      setDeletingCompanyId(companyId);
      const response = await axiosInstance.post("/company/delete/", {
        company_id: companyId,
      }, { timeout: 120000 });
      message.success(response?.data?.message || "Company deleted successfully");
      fetchCompanies();
    } catch (error) {
      message.error(error?.response?.data?.error || "Failed to delete company");
    } finally {
      setDeletingCompanyId(null);
    }
  };

  const companiesColumns = [
    {
      title: "Company Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Admin Contact No.",
      dataIndex: "admin_contact_number",
      key: "admin_contact_number",
    },
    {
      title: "Admin Name",
      dataIndex: "name_of_admin",
      key: "name_of_admin",
    },
    {
      title: "Admin Email",
      dataIndex: "admin_email",
      key: "admin_email",
    },
    {
      title: "Valid From",
      dataIndex: "valid_from",
      key: "valid_from",
      render: (date) => formatIndianDate(date),
    },
    {
      title: "Valid To",
      dataIndex: "valid_to",
      key: "valid_to",
      render: (date) => formatIndianDate(date),
    },
    {
      title: "Change Status",
      dataIndex: "is_active",
      key: "is_active",
      render: (text, record) => (
        <>
          {record.is_active ? (
            <div
              onClick={() => showADeactivateeModal(record.id)}
              type="submit"
              className="rounded-full border-2 border-red px-6 flex justify-center items-center pt-2 bg-red-400 text-xs font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-danger-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-danger-600 focus:border-danger-600 focus:text-danger-600 focus:outline-none focus:ring-0 active:border-danger-700 active:text-danger-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10"
            >
              Deactivate
            </div>
          ) : (
            <div
              onClick={() => showCompanyActiveModal(record.id)}
              className="rounded-full border-2 border-success px-6 flex justify-center items-center pt-2 bg-green-500 text-xs font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-success-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-success-600 focus:border-success-600 focus:text-black focus:outline-none focus:ring-0 active:border-success-700 active:text-black-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10"
            >
              Activate
            </div>
          )}
        </>
      ),
    },
    {
      title: "Premium",
      dataIndex: "is_premium",
      key: "is_premium",
      render: (text, record) => (
        <Tooltip title={record.is_premium ? 'Premium' : 'Non Premium'}>
          <Button
            type="primary"
            shape="circle"
            size="large"
            onClick={() => onPrimum(!record.is_premium, record?.user_id)}
            icon={
              record.is_premium ? (
                <CrownOutlined className="text-yellow-400 text-2xl" />
              ) : (
                <CloseCircleOutlined className="text-gray-500 text-2xl" />
              )
            }
            className="w-16 h-16 flex items-center justify-center shadow-lg hover:shadow-xl transition duration-300"
          />
        </Tooltip>
      ),
    },
    ...(user_role?.toLowerCase() === "superadmin" ? [{
      title: "Action",
      key: "company_actions",
      fixed: "right",
      render: (text, record) => (
        <Space size="small" wrap className="flex items-center">
          <Tooltip title="Stop Email Task">
            <Popconfirm
              title="Stop Email Task"
              description="Stop 7-day auto emails for this company?"
              onConfirm={() => handleStopEmailTask(record.id)}
              okText="Stop"
              cancelText="Cancel"
            >
              <Button
                type="primary"
                shape="circle"
                size="small"
                danger
                icon={<StopOutlined />}
              />
            </Popconfirm>
          </Tooltip>
          <Tooltip title="Delete Company">
            <Popconfirm
              title="Delete Company"
              description="Are you sure you want to delete this company? Data will not exist after deleting this company."
              onConfirm={() => handleDeleteCompany(record.id)}
              okText="Delete"
              cancelText="Cancel"
              okButtonProps={{ danger: true, loading: deletingCompanyId === record.id }}
            >
              <Button
                shape="circle"
                size="small"
                danger
                loading={deletingCompanyId === record.id}
                icon={<DeleteOutlined />}
              />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    }] : []),
    {
      title: "View details",
      dataIndex: "first_name",
      key: "first_name",
      render: (text, record) => (
        <Link
          to={{
            pathname: `/admin/company/${record.id}`,
          }}
        >
          <button
            type="submit"
          >
            <RightArrowIcon />
          </button>
          {/* <Button
            type="submit"
            className="inline-block rounded-full border-2 border-red px-6 pb-[6px] pt-2 bg-blue-400 text-xs font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-danger-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-danger-600 focus:border-danger-600 focus:text-danger-600 focus:outline-none focus:ring-0 active:border-danger-700 active:text-danger-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10"
          >
            View details
          </Button> */}
        </Link>
      ),
    },
  ];

  const handleOk = () => {
    form.submit();
  };

  const departments = company && company.department_list;

  const fetchProduct = async () => {
    try {
      const response = await axiosInstance.get(`/company/get_product/?company_id=${companyid || company_id}`, {
        customParams: config,
      });
      setProducts(response.data.data); // Update the state with the fetched user data
    } catch (error) {
      console.log('error', error)
    }
  };

  const handleDepartment = (values) => {
    values.department_list.push(...departments);

    axiosInstance.patch(`/company/${company_id && company_id}/update/`, values).then((response) => {
      // Handle successful response
      setEditMode(false);
      settingsUpdate(response.data.message);
      fetchCompanys();
      setIsModalOpen(false);
      addDepartmentFrom.resetFields();
    })
      .catch((error) => {
        message.error("Some error occured while updating. Please try again.");
        // settingsUpdateError(
        //   "Some error occured while updating. Please try again."
        // );
      });

    setEditMode(false);
  };

  const handleProduct = (values) => {
    const product_list = [
      ...products.map((item) => item.product_name),
      ...(Array.isArray(values.product_list) ? values.product_list : []),
    ];

    axiosInstance.put(`/company/add_product/`, { product_list })
      .then((response) => {
        // Handle successful response
        setEditMode(false);
        setIsProductModal(false);
        settingsUpdate(response.data.message);
        fetchProduct();
        addProductFrom.resetFields();
      })
      .catch((error) => {
        settingsUpdateError(
          "Some error occured while updating. Please try again."
        );
      });
  };

  const deleteDepartment = (values) => {
    let data = {
      department_list: departments.filter((item) => item !== values),
    };

    axiosInstance.patch(`/company/${company_id && company_id}/update/`, data)
      .then((response) => {
        // Handle successful response
        message.success("Department successfully deleted.");
        fetchCompanys();
      })
      .catch((error) => {
        message.error("An error occured.");
        console.error("Error updating user details:", error);
      });
  };

  const deleteProduct = (values) => {
    let data = products
      .filter((item) => item.product_name !== values)
      .map((item) => item.product_name);

    axiosInstance.put(`/company/add_product/`, { product_list: data })
      .then((response) => {
        // Handle successful response
        message.success("Product successfully deleted.");
        fetchProduct();
      })
      .catch((error) => {
        message.error("An error occured.");
        console.error("Error updating user details:", error);
      });
  };

  const handleFinishExtraField = (values, data) => {
    let transformedObject, newKey;
    if (values === 'editCustomField') {
      if (!data) {
        const hasEmptyValues = editableExterFieldData?.flat()?.some(value => !value.trim());
        if (hasEmptyValues) {
          message.error('Every field should be fill up in custom tab')
          return false;
        }
      }
      newKey = data ? Object.fromEntries(data) : Object.fromEntries(editableExterFieldData);
    } else {
      transformedObject = values?.extra_fields?.reduce((acc, obj) => {
        const { field, value } = obj;
        acc[field] = value;
        return acc;
      }, {});
      newKey = { ...transformedObject, ...company?.extra_field };
    }

    axiosInstance.patch(`/company/${company_id && company_id}/update/`, { extra_field: newKey })
      .then((response) => {
        // Handle successful response
        fetchCompanys();
        if (values === 'editCustomField') {
          setIsCustomFieldEditMode(false);
          return;
        }
        setEditMode(false);
        settingsUpdate(response.data.message);
        setIsExtraFieldModalOpen(false);
        form.resetFields();
      })
      .catch((error) => {
        settingsUpdateError(
          "Some error occured while updating. Please try again."
        );
        console.error("Error updating user details:", error);
      });

    setEditMode(false);
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const showCompanyActiveModal = (companyId) => {
    setActiveOpen(true);
    setCompanyId(companyId);
  };
  const showADeactivateeModal = (companyId) => {
    setDeactivateModal(true);
    setCompanyId(companyId);
  };
  const showCompanyCreateModal = () => {
    setIsCompanyCreatedModalOpen(true);
  };
  const showProductModal = () => {
    setIsProductModal(true);
  };
  const showExtraFieldModal = () => {
    setIsExtraFieldModalOpen(true);
  };
  const handleOkExtraField = () => {
    setIsExtraFieldModalOpen(false);
  };
  const handleOkCompanyCreate = async () => {
    await form.validateFields();
    const values = await form.getFieldsValue();
    // setIsCompanyCreatedModalOpen(false);
    console.log(values);
  };
  const handleCancelModal = () => {
    setIsModalOpen(false);
    setIsExtraFieldModalOpen(false);
    setIsProductModal(false);
    setIsCompanyCreatedModalOpen(false);
    setDeactivateModal(false);
    form.resetFields();
  };
  const handleCancelExtraFieldModal = () => {
    setIsExtraFieldModalOpen(false);
  };
  const handleEdit = () => {
    if (
      (user_role && user_role.toLowerCase() === "admin") ||
      user_role.toLowerCase() === "superadmin"
    ) {
      console.log("edit mode", editMode);
      setEditMode(true);
    }
  };

  const fetchState = async (value) => {
    try {
      const response = await axiosInstance.get("/state/get/", {
        customParams: {
          country_id: value.value,
        },
      });

      setStates(response.data); // Update the state with the fetched user data
    } catch (error) { }
  };

  const handleCancel = () => {
    setEditMode(false);
    setEditedCompany({ ...company });
    setActiveOpen(false);
    setIsCompanyCreatedModalOpen(false);
    setDeactivateModal(false);
    form.resetFields();
  };

  const handleCountryChange = (value) => {
    form.setFieldsValue({ "address.country": value });
    // form.setFieldsValue({ "address.state": null });

    setCompanyID(value.value);
    setEditedCompany((prevAddress) => ({
      ...prevAddress,
      address: {
        ...prevAddress.address,
        country: value.value,
      },
    }));
    fetchState(value);
  };

  const handleAdress1Change = (e) => {
    const { name, value } = e.target;
    setEditedCompany((prevAddress) => ({
      ...prevAddress,
      address: {
        ...prevAddress.address,
        [name]: value,
      },
    }));
  };

  const handleAddress2Change = (e) => {
    const { name, value } = e.target;
    setEditedCompany((prevAddress) => ({
      ...prevAddress,
      address: {
        ...prevAddress.address,
        [name]: value,
      },
    }));
  };
  const handleCityChange = (e) => {
    const { name, value } = e.target;
    setEditedCompany((prevAddress) => ({
      ...prevAddress,
      address: {
        ...prevAddress.address,
        [name]: value,
      },
    }));
  };

  const handlePinChange = (e) => {
    const { name, value } = e.target;
    setEditedCompany((prevAddress) => ({
      ...prevAddress,
      address: {
        ...prevAddress.address,
        [name]: value,
      },
    }));
  };

  const handleStateChange = (value) => {
    console.log(value, "KJSHDjkahsdjkhasd");
    setEditedCompany((prevAddress) => ({
      ...prevAddress,
      address: {
        ...prevAddress.address,
        state: value.value,
      },
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedCompany((prevCompany) => ({
      ...prevCompany,
      [name]: value,
    }));
  };

  const fetchCompanys = async () => {
    try {
      const response = await axiosInstance.get(`/company/${companyid || company_id}/get/`, {
        customParams: config
      });

      setCompany(response.data);
      setEditedCompany(response.data);
      dispatch(setStoreDetails({ currency: response.data.currency }))
      const {
        address: { state, country, ...addressWithoutCountryState },
        ...otherData
      } = response.data;
      const editedCompany = {
        address: {
          ...addressWithoutCountryState,
          country: country && country.id,
          state: state && state.id,
        },
        ...otherData,
      };
      setEditedCompany(editedCompany);
    } catch (error) { }
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    const newParams = new URLSearchParams(location.search);
    newParams.set("tab", key);
    navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
  };

  const handleNext = () => {
    form.validateFields().then(() => {
      const nextTab = (parseInt(activeTab, 10) % finalPage) + 1;
      const nextTabStr = nextTab.toString();
      setActiveTab(nextTabStr);

      const newParams = new URLSearchParams(location.search);
      newParams.set("tab", nextTabStr);
      navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    });
  };

  const handlePrevious = () => {
    const previousTab = ((parseInt(activeTab, 10) - 2 + finalPage) % finalPage) + 1;
    const previousTabStr = previousTab.toString();
    setActiveTab(previousTabStr);

    const newParams = new URLSearchParams(location.search);
    newParams.set("tab", previousTabStr);
    navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
  };


  const handleCompanyStatus = (action) => {
    const reason = form.getFieldValue('reason');
    if (!reason && action === "deactivate") {
      return false;
    }
    const payload = {
      active: action === "deactivate" ? false : true,
      ...(action === "deactivate" && { reason }),
    }
    axiosInstance.put(`/company/${companyId}/active/`, payload)
      .then((response) => {
        if (response.status === 200) {
          form.resetFields();
          setDeactivateModal(false);
          setActiveOpen(false);
          fetchCompanies();
          message.success("Company deactivated successfully.");
        } else {
          setDeactivateModal(false);
          setActiveOpen(false);
          message.error("An error occured. Please try again.");
        }
      })
      .catch((error) => {
        setDeactivateModal(false);
        setActiveOpen(false);

        message.error(error?.response?.data.error);
      });
  };
  const onFinish = async () => {
    await form.validateFields();
    const values = await form.getFieldsValue();
    setEditedCompany({ ...editedCompany, name: values.name });
    try {

      axiosInstance.patch(`/company/${company_id && company_id}/update/`, editedCompany)
        .then((response) => {
          setEditMode(false);
          fetchCompanys();
          settingsUpdate(response.data.message);
        })
        .catch((error) => {
          setEditMode(false);
          message.error(error.response.data.error);
        });
    } catch (errorInfo) {
      console.log(errorInfo);
      // setActiveTab("1");
      const errorFields = errorInfo.errorFields[0].name;
      message.error(`Form validation failed, please check all the fields.`);
    }
  };
  const handleCompanyCreate = async () => {
    await form.validateFields();
    const values = await form.getFieldsValue();
  };

  const handleCurrencyChange = (value) => {
    setEditedCompany((prevAddress) => ({
      ...prevAddress,
      currency: value.value,
    }));
  };

  const handleCompanySearch = (value) => {
    setCompanySearch(value || "");
  };

  const filteredCompanies = useMemo(() => {
    const query = companySearch.trim().toLowerCase();
    if (!query) return allCompanies || [];
    return (allCompanies || []).filter((companyItem) =>
      (companyItem?.name || "").toLowerCase().includes(query)
    );
  }, [allCompanies, companySearch]);

  const handelCloseCustomFieldEditMode = () => {
    setIsCustomFieldEditMode(false);
    setOriginalCustomFields()
  }

  const handleCustomFormChange = (value, index, name) => {
    const updatedCustomForm = [...editableExterFieldData];
    if (name === "field") {
      updatedCustomForm[index][0] = value;
    } else {
      updatedCustomForm[index][1] = value
    }
    setEditableExterFieldData([...updatedCustomForm])
  }
  const customTabColumns = useMemo(() => {
    return [
      {
        title: "Particular",
        dataIndex: "field",
        render: (_, record, index) => (
          <>
            {isCustomFieldEditMode ? (
              <Input
                name={"field"}
                defaultValue={record[0]}
                onChange={(e) =>
                  handleCustomFormChange(e.target.value, index, e.target.name)
                }
              />
            ) : (
              <h1>{record[0]}</h1>
            )}
          </>
        ),
      },

      {
        title: "Details",
        dataIndex: "value",
        render: (_, record, index) => (
          <>
            {isCustomFieldEditMode ? (
              <Input
                name={"value"}
                defaultValue={record[1]}
                onChange={(e) =>
                  handleCustomFormChange(e.target.value, index, e.target.name)
                }
              />
            ) : (
              <h1>{record[1]}</h1>
            )}
          </>
        ),
      },
      ...(!isCustomFieldEditMode && (
        !isCustomFieldEditMode && (user_role && user_role.toLowerCase() === "admin" ||
          user_role.toLowerCase() === "superadmin")
      )
        ? [
          {
            title: "Delete Field",
            dataIndex: "age",
            key: "age",
            render: (_, record, index) => (
              <span>
                <Popconfirm
                  title="Delete Custom Field"
                  description="Are you sure to delete this Field?"
                  okText="Yes"
                  cancelText="No"
                  onConfirm={() => {
                    setOriginalCustomFields()
                    const tempData = [...editableExterFieldData];
                    tempData.splice(index, 1);
                    handleFinishExtraField('editCustomField', tempData)
                    setEditableExterFieldData([...tempData])
                  }
                  }
                >
                  <Button danger>
                    <DeleteOutlined />
                  </Button>
                </Popconfirm>
              </span>
            ),
          },
        ]
        : []),
    ];
  }, [editableExterFieldData, isCustomFieldEditMode])

  const setOriginalCustomFields = () => {
    if (company?.extra_field) {
      setEditableExterFieldData(Object.entries(company.extra_field))
    }
  }

  const renderGroupedNotes = () => {
    const groups = {};

    noteList.forEach((note) => {
      const date = dayjs(note.created_at);
      let label = date.format("DD MMM YYYY");
      if (date.isToday()) label = "Today";
      else if (date.isYesterday()) label = "Yesterday";

      if (!groups[label]) groups[label] = [];
      groups[label].push(note);
    });

    return Object.entries(groups).map(([label, notes]) => (
      <div key={label} style={{ marginBottom: "16px" }}>
        <h3 className="text-sm text-gray-500 font-medium mb-2">{label}</h3>

        {notes.map((note) => (
          <div
            key={note.id}
            style={{
              backgroundColor: "#2563EB",
              padding: "10px 14px",
              borderRadius: "12px",
              marginTop: "8px",
              maxWidth: "80%",
              color: "white",
              wordWrap: "break-word",
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: "14px",
                lineHeight: "1.4",
                wordBreak: "break-word",
              }}
            >
              {note.note}
            </p>
            <div
              style={{
                fontSize: "11px",
                textAlign: "right",
                marginTop: "6px",
                color: "#d1d5db", // Tailwind's gray-300
              }}
            >
              {dayjs(note.created_at).format("h:mm A")}
            </div>
          </div>
        ))}
      </div>
    ));
  };

  const handleOpenNoteModal = async (record) => {
    setSelectedRecord(record);
    setNoteInput("");
    setNoteList([]);
    setNoteLoading(true);
    try {
      const res = await axiosInstance.get(`/demo/${record.id}/notes/`);
      setNoteList(res?.data || []);
    } catch (err) {
      console.error("Failed to fetch note:", err);
    }

    setNoteLoading(false);
    setIsReadNotesModalOpen(true);
    setTimeout(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
      }
    }, 200);
  };

  const handleNoteSubmit = async () => {
    if (!noteInput.trim()) return;
    setNoteLoading(true);

    try {
      await axiosInstance.post(`/demo/${selectedRecord.id}/add-note/`, {
        note: noteInput,
      });
      setNoteInput("");
      // Re-fetch notes
      const res = await axiosInstance.get(`/demo/${selectedRecord.id}/notes/`);
      setNoteList(res?.data || []);
      setTimeout(() => {
        if (chatContainerRef.current) {
          chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
      }, 200);
    } catch (err) {
      console.error("Failed to add note:", err);
      message.error("Failed to add note.");
    }

    setNoteLoading(false);
  };

  const generateAvailableSlots = (timezone = "Asia/Kolkata") => {
    const slots = {};
    const startHour = 10;
    const endHour = 18;

    for (let i = 0; i < 30; i++) {
      const date = dayjs().tz(timezone).add(i, "day");
      const dayOfWeek = date.day(); // 0 (Sunday) - 6 (Saturday)

      if (dayOfWeek >= 1 && dayOfWeek <= 5) {
        // Only Monday - Friday
        const formattedDate = date.format("YYYY-MM-DD");
        slots[formattedDate] = [];

        for (let hour = startHour; hour < endHour; hour++) {
          slots[formattedDate].push(`${hour.toString().padStart(2, "0")}:00`);
          slots[formattedDate].push(`${hour.toString().padStart(2, "0")}:30`);
        }
      }
    }
    return slots;
  };

  const convertTime = (time, date, selectedTimezone, localTimeZone) => {
    const localDateTime = dayjs.tz(`${date} ${time}`, "YYYY-MM-DD HH:mm", localTimeZone).tz(selectedTimezone);
    const adjustedDate = localDateTime.format("YYYY-MM-DD");
    const adjustedTime = localDateTime.format("HH:mm");
    return { adjustedDate, adjustedTime }
  }
  const getDate = async () => {
    try {
      const response = await axiosInstance.get(`/demo/busy-slots/`);
      setUnavailableData(response.data.blocked_slots);
    } catch (error) {
      message.error(error.response.data.error);
    }
  }
  if (rescheduleLoading) {
    message.loading("Rescheduling meeting...", 0);
  }
  const dateCellRender = (value) => {
    return timezoneAdjustedData[value.format("YYYY-MM-DD")] ? null : <div style={{ color: "#bbb" }}></div>;
  };

  const isPast = (date, slot) => dayjs.tz(`${date} ${slot}`, "YYYY-MM-DD HH:mm", selectedTimezone).isBefore(dayjs().tz(selectedTimezone));

  const getFormattedDate = (date) => {
    if (!date) return "";
    const dayjsDate = dayjs(date);
    const day = dayjsDate.date();
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return "th"; // 11-13
      switch (n % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };

    const suffix = getOrdinal(day);
    const formatted = `${dayjsDate.format("dddd, MMMM")} ${day}${suffix} ${dayjsDate.format("YYYY")}`;
    return formatted;
  };

  useEffect(() => {
    const rawAvailableData = Object.keys(availableData).length > 0 ? { ...availableData } : generateAvailableSlots(selectedTimezone);
    const adjustTimeData = (data) => {
      const adjustedData = {};
      Object.keys(data).forEach((date) => {
        data[date].forEach((time) => {
          const { adjustedDate, adjustedTime } = convertTime(time, date, selectedTimezone, "Asia/Kolkata");
          if (!adjustedData[adjustedDate]) adjustedData[adjustedDate] = [];
          adjustedData[adjustedDate].push(adjustedTime);
        });
      });
      return adjustedData;
    };


    const adjustedAvailableData = adjustTimeData(rawAvailableData);
    const adjustedUnavailableData = adjustTimeData(bookedSlots);
    setTimezoneAdjustedData(adjustedAvailableData);
    setTimezoneAdjustedUnavailable(adjustedUnavailableData);
  }, [selectedTimezone, availableData, bookedSlots]);

  useEffect(() => {
    setBookedSlots(unavailableData);
  }, [unavailableData]);

  useEffect(() => {
    if (company?.extra_field) {
      setOriginalCustomFields()
    }
  }, [company?.extra_field])

  useEffect(() => {
    getDate()
  }, []);

  useEffect(() => {
    fetchProduct();
    if (user_role === "superadmin") {
      fetchCompanies();
    }
  }, []);
  useEffect(() => {
    const userNavigate = localStorage.getItem("gyrwmnqijpkl")
    if (userNavigate === "xvzndrpkloqy") {
      setActiveTab("5");
      localStorage.removeItem("gyrwmnqijpkl");
    } else if (userNavigate === "xvzndrpkloqo9") {
      setActiveTab("7");
      localStorage.removeItem("gyrwmnqijpkl");
    }
  }, []);
  useEffect(() => {
    fetchCompanys();
  }, [editMode]);

  useEffect(() => {
    if (!company || !company.address || !company.address.country) return;
    fetchState({ value: company.address.country.id });
  }, [company]);

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await axiosInstance.get("/country/get/");
        setCountries(response.data); // Update the state with the fetched user data
      } catch (error) { }
    };
    fetchCountry();
  }, []);

  useEffect(() => {
    if (user_role === "superadmin" || user_role === "demo") {
      fetchDemoRequests();
    }
  }, [user_role, token]);

  const config = {
    search: ""
  };

  useEffect(() => {
    if (user_role === "superadmin") {
      setFinalPage(11);
    } else if (user_role === "admin") {
      setFinalPage(7);
    } else {
      setFinalPage(6);
    }
  }, [user_role]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const codes = await getAllISOCodes();
        const transformedData = codes.map((code) => ({
          value: `${code.countryName} (${code.symbol})`,
          label: `${code.countryName} (${code.symbol})`,
        }));
        setAllCurrency(transformedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    checkProduct()
  }, []);


  return (
    <>
      {company ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
            }}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              encType="multipart/form-data"
            >
              <Tabs
                activeKey={activeTab}
                onChange={handleTabChange}
                type="card"
                size="small"
                style={{ flex: 1 }}
              >
                <TabPane tab="Company Details" key="1">
                  <CompanyDetails
                    company={company}
                    editedCompany={editedCompany}
                    editMode={editMode}
                    isEdtBaCurr={isEdtBaCurr}
                    allCurrency={allCurrency}
                    countries={countries}
                    states={states}
                    companyID={companyID}
                    handleEdit={handleEdit}
                    handleInputChange={handleInputChange}
                    handleCurrencyChange={handleCurrencyChange}
                    handleCountryChange={handleCountryChange}
                    handleAdress1Change={handleAdress1Change}
                    handleAddress2Change={handleAddress2Change}
                    handleCityChange={handleCityChange}
                    handlePinChange={handlePinChange}
                    handleStateChange={handleStateChange}
                    handleCancel={handleCancel}

                  />
                </TabPane>
                <TabPane tab="Departments" key="2">
                  <DepartmentPage
                    company={company}
                    isModalOpen={isModalOpen}
                    showModal={showModal}
                    handleCancelModal={handleCancelModal}
                    handleDepartment={handleDepartment}
                    deleteDepartment={deleteDepartment}
                    addDepartmentFrom={addDepartmentFrom}
                  />
                </TabPane>
                <TabPane tab="Products / Services" key="3">
                  <ProductService
                    products={products}
                    isProductModal={isProductModal}
                    showProductModal={showProductModal}
                    handleCancelModal={handleCancelModal}
                    addProductFrom={addProductFrom}
                    handleProduct={handleProduct}
                    deleteProduct={deleteProduct}
                  />
                </TabPane>
                <TabPane tab="Custom Fields" key="4">
                  <CustomFeilds
                    isCustomFieldEditMode={isCustomFieldEditMode}
                    setIsCustomFieldEditMode={setIsCustomFieldEditMode}
                    editableExterFieldData={editableExterFieldData}
                    // setEditableExterFieldData={setEditableExterFieldData}
                    showExtraFieldModal={showExtraFieldModal}
                    isExtraFieldModalOpen={isExtraFieldModalOpen}
                    handleOkExtraField={handleOkExtraField}
                    handleCancelExtraFieldModal={handleCancelExtraFieldModal}
                    form={form}
                    handleFinishExtraField={handleFinishExtraField}
                    handelCloseCustomFieldEditMode={handelCloseCustomFieldEditMode}
                    customTabColumns={customTabColumns}
                  />
                </TabPane>
                <TabPane tab="Users" key="5">
                  <UserTab />
                </TabPane>
                <TabPane tab="Download" key="6">
                  <DownloadTab allExuonDate={editedCompany?.date_of_execution} exuonDate={editedCompany?.date_of_execution[0] || ''} />
                </TabPane>
                {user_role === "admin" && (
                  <TabPane tab="Bulk Upload" key="7">
                    <BulkUploadTab />
                  </TabPane>
                )}
                {user_role === "superadmin" && (
                  <>
                    <TabPane tab="Companies" key="7">
                      <>
                        <div className=" text-black pb-3 px-2 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                          <span className="flex flex-row items-center w-full">
                            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-start sm:items-center w-full">

                              <h1 className="font-semibold text-[15px] pt-[1%] dark:text-white">
                                Companies
                              </h1>
                              <CustomSearch onSearch={handleCompanySearch} onChange={handleCompanySearch} />
                            </div>
                          </span>
                          <Modal
                            title="Add Company"
                            open={isCompanyCreateModalOpen}
                            onOk={handleOkCompanyCreate}
                            onCancel={handleCancel}
                            style={{ fontSize: "24px", padding: "40px" }}
                            okText="Create"
                            okButtonProps={{
                              style: {
                                backgroundColor: "#4E36A3",
                                color: "white",
                                height: "40px",
                                width: "100px",
                              },
                              disabled: loading, // Disable the button when loading is true
                            }} // Set background color for the Ok button
                            cancelButtonProps={{
                              style: {
                                backgroundColor: "",
                                color: "#4E36A3",
                                height: "40px",
                                width: "100px",
                              },
                            }} // Set background color for the Cancel button
                          >
                            {/* <p>{modalText}</p> */}
                            <Form form={form} onFinish={handleCompanyCreate}>
                              <Col>Name of User</Col>

                              <Form.Item label="" name="first_name">
                                <Input placeholder="" />
                              </Form.Item>
                              <Col>Company Name</Col>

                              <Form.Item label="" name="name">
                                <Input placeholder="" />
                              </Form.Item>
                              <Col>Email Address</Col>
                              <Form.Item label="" name="admin_email">
                                <Input placeholder="" />
                              </Form.Item>
                              <Col>Contact Number</Col>

                              <Form.Item label="" name="admin_contact_number">
                                <Input
                                  placeholder=""
                                  pattern="[0-9]{10}"
                                  title="Please enter a 10-digit contact number."
                                />
                              </Form.Item>
                              <Col>Country</Col>

                              <Form.Item label="" name="country">
                                <Select
                                  placeholder="Select Country"
                                  onChange={handleCountryChange}
                                  menuPlacement="top"
                                  options={
                                    countries &&
                                    countries.map((country) => ({
                                      // value: state.isoCode,
                                      value: country.id,
                                      label: country.name,
                                    }))
                                  }
                                />
                              </Form.Item>
                            </Form>
                          </Modal>
                        </div>

                        <div>
                          {loading ? (
                            <div className="text-center top-3 left-3">
                              <LoadingOutlined style={{ fontSize: "5rem" }} />
                            </div>
                          ) : (
                            <Table
                              dataSource={filteredCompanies}
                              columns={companiesColumns}
                              rowKey="id"
                              size="small"
                              className="overflow-y-scroll text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]"
                              scroll={{ x: "max-content" }}
                            />
                          )}
                        </div>
                        <Modal
                          title="Deactivate"
                          open={deactivateModal}
                          onOk={() => handleOk()}
                          onCancel={handleCancel}
                        >
                          <Form
                            form={form}
                            onFinish={() => handleCompanyStatus("deactivate")}
                          >
                            <Form.Item
                              name="reason"
                              label="Reason"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter deactivation reason.",
                                },
                              ]}
                            >
                              <TextArea />
                            </Form.Item>
                          </Form>
                        </Modal>
                        <Modal
                          title="Activate"
                          open={activeOpen}
                          onOk={() => handleCompanyStatus('Active')}
                          // onOk={() => handleCompanyActivate(companyId)}
                          onCancel={handleCancel}
                        >
                          <p>{modalText}</p>
                        </Modal>
                      </>
                    </TabPane>
                    <TabPane className="relative" tab="Professional Companies" key="8">
                      <ProfessionalCompanies />
                    </TabPane>
                  </>
                )}
                {(user_role === "superadmin" || user_role === "demo") && (
                  <TabPane className="relative" tab="Demo Requests" key="9">
                    <DemoRequests
                      isRescheduleModalOpen={isRescheduleModalOpen}
                      setIsRescheduleModalOpen={setIsRescheduleModalOpen}
                      rescheduleDate={rescheduleDate}
                      setRescheduleDate={setRescheduleDate}
                      rescheduleTime={rescheduleTime}
                      setRescheduleTime={setRescheduleTime}
                      timezoneAdjustedData={timezoneAdjustedData}
                      timezoneAdjustedUnavailable={timezoneAdjustedUnavailable}
                      isPast={isPast}
                      getFormattedDate={getFormattedDate}
                      setRescheduleLoading={setRescheduleLoading}
                      convertTime={convertTime}
                      selectedTimezone={selectedTimezone}
                      meetingIdToReschedule={meetingIdToReschedule}
                      axiosInstance={axiosInstance}
                      message={message}
                      fetchDemoRequests={fetchDemoRequests}
                      getDate={getDate}
                      noteLoading={noteLoading}
                      noteList={noteList}
                      isReadNotesModalOpen={isReadNotesModalOpen}
                      setIsReadNotesModalOpen={setIsReadNotesModalOpen}
                      chatContainerRef={chatContainerRef}
                      noteInput={noteInput}
                      setNoteInput={setNoteInput}
                      handleNoteSubmit={handleNoteSubmit}
                      handleOpenNoteModal={handleOpenNoteModal}
                      demoRequests={demoRequests}
                      loading={loading}
                      setSelectedRecord={setSelectedRecord}
                      setMeetingIdToReschedule={setMeetingIdToReschedule}
                      dateCellRender={dateCellRender}
                      renderGroupedNotes={renderGroupedNotes}
                    />
                  </TabPane>
                )}
                {(user_role === "superadmin" || user_role === "support") && (
                  <>
                    <TabPane tab="Tickets" key="10">
                      <TicketList />
                    </TabPane>
                    <TabPane tab="Meeting" key="11">
                      <Meeting />
                    </TabPane>
                  </>
                )}
              </Tabs>
            </Form>
            <div
              style={{
                position: "relative",
                bottom: 0,
                left: 0,
                display: "flex",
                justifyContent: "flex-start",
                paddingTop: "30px",
              }}
            >
              {activeTab !== "1" && (
                <ButtonComp
                  text="Previous"
                  textColor="#4E36A3"
                  bgColor="white"
                  onClick={handlePrevious}
                  margin="2rem"
                />
              )}
              {parseInt(activeTab) !== parseInt(finalPage) ? (
                <>
                  {editMode ? (
                    ""
                  ) : (
                    <ButtonComp
                      text="Next"
                      bgColor="#4E36A3"
                      textColor="white"
                      onClick={handleNext}
                    />
                  )}
                </>
              ) : (
                <>
                  {editMode ? (
                    ""
                  ) : (
                    <ButtonComp
                      text="Finish"
                      bgColor="#4E36A3"
                      textColor="white"
                      onClick={handleNext}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        ""
      )}
     
    </>
  );
}
export default SettingsPage;
